import { render, staticRenderFns } from "./Camera.vue?vue&type=template&id=116164f5&"
import script from "./Camera.vue?vue&type=script&lang=js&"
export * from "./Camera.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports